"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateRangeFilter = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const BaseFilter_1 = require("./BaseFilter");
const Label_1 = require("../Label");
const inputs_1 = require("../../inputs");
const defaultTestId_1 = require("../../utils/defaultTestId");
function dateRangeFilter(props) {
    return (key) => new DateRangeFilter(key, props);
}
exports.dateRangeFilter = dateRangeFilter;
class DateRangeFilter extends BaseFilter_1.BaseFilter {
    render(value, setValue, tid, inModal, vertical) {
        const { label, placeholderText, disabledDays, testFieldLabel, defaultValue } = this.props;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [vertical && (0, jsx_runtime_1.jsx)(Label_1.Label, { label: label }), (0, jsx_runtime_1.jsx)(inputs_1.DateRangeField, { compact: true, labelStyle: "inline", isRangeFilterField: true, placeholder: placeholderText, label: testFieldLabel !== null && testFieldLabel !== void 0 ? testFieldLabel : "Date", 
                    // Making sure that DateRange is Date type and not string before passing. Will never have undefined from/to
                    value: (value === null || value === void 0 ? void 0 : value.value)
                        ? { from: new Date(value.value.from), to: new Date(value.value.to) }
                        : undefined, onChange: (d) => (d ? setValue({ op: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.op, value: d }) : setValue(undefined)), disabledDays: disabledDays, ...tid[`${(0, defaultTestId_1.defaultTestId)(this.label)}_dateField`] })] }));
    }
}
